const UTM_MEDIUM: string = 'utm_medium';
const UTM_CAMPAIGN: string = 'utm_campaign';
const UTM_CONTENT: string = 'utm_content';
const UTM_TERM: string = 'utm_term';
const UTM_SOURCE: string = 'utm_source';

const PAGE_TITLE: string = 'page_title';
const PAGE_URL: string = 'page_url';
const PAGE_PATH: string = 'page_path';
const PAGE_SEARCH: string = 'page_search';
const PAGE_PROPERTIES = [PAGE_TITLE, PAGE_URL, PAGE_PATH, PAGE_SEARCH];
const PAGE_PROPERTIES_MAP = new Map<string, () => string>([
  [PAGE_TITLE, () => document.title],
  [PAGE_URL, () => window.location.href],
  [PAGE_PATH, () => window.location.pathname],
  [PAGE_SEARCH, () => window.location.search]
]);

const EXTERNAL_REFERRER: string = 'external_referrer';

const CAMPAIGN_PROPERTIES = [
  UTM_MEDIUM,
  UTM_CAMPAIGN,
  UTM_CONTENT,
  UTM_TERM,
  UTM_SOURCE
];

const GCLID: string = 'gclid'; // Google Click ID
const FBCLID: string = 'fbclid'; // Facebook click ID
const MSCLKID: string = 'msclkid'; // Microsoft click ID

const ADS_PROPERTIES = [GCLID, FBCLID, MSCLKID];

const ALL_ATTRIBUTION_PROPERTIES = [
  ...CAMPAIGN_PROPERTIES,
  ...ADS_PROPERTIES,
  ...PAGE_PROPERTIES
];

export {
  ALL_ATTRIBUTION_PROPERTIES,
  PAGE_PROPERTIES,
  PAGE_PROPERTIES_MAP,
  CAMPAIGN_PROPERTIES,
  ADS_PROPERTIES,
  UTM_MEDIUM,
  UTM_CAMPAIGN,
  UTM_CONTENT,
  UTM_TERM,
  UTM_SOURCE,
  GCLID,
  FBCLID,
  MSCLKID,
  EXTERNAL_REFERRER
};
